module.exports = __webpack_public_path__ + "static/media/linemenu-background@3x.9ba32399.png";